import http from '../../utils/httpService';
import {  SEND_USER_IDENTIFIER_ROUTE  } from './constants';

/**
 *
 * @param form
 */
const sendIdentifierRequest = () => (
    http.request( SEND_USER_IDENTIFIER_ROUTE , 'GET')
);

export { sendIdentifierRequest };